<!--

企业实体信息的详细页面，表示一个企业实体，可以进入编辑模式

-->
<template>
  <div>
    <div style="text-align: right; margin-bottom: 12px">
      <!-- 否则显示启动编辑按钮 -->
      <el-button
        icon="el-icon-edit"
        type="warning"
        round
        size="large"
        style="padding: 4px 12px"
        @click="startEdit"
      >
        编辑
      </el-button>
    </div>
    <!-- 否则显示详细界面 -->
    <template>
      <el-form ref="form" size="mini" label-position="top">
        <el-row :gutter="20">
          <!-- 左栏 -->
          <el-col :span="16">
            <!-- 第一行 -->
            <el-row :gutter="10">
              <el-col :span="10">
                <el-form-item label="企业全称">
                  <span>{{ enterpriseItem.name }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="企业简称">
                  <span>{{ enterpriseItem.nameAbbr }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="信用代码">
                  <span>{{ enterpriseItem.credit }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="成立年份">
                  <span>{{ enterpriseItem.foundYear }} 年</span>
                </el-form-item>
              </el-col>
              <!-- 第二行 -->
              <!-- <el-col :span="10">
                <el-form-item label="所在乡镇">
                  <span>
                    {{ enterpriseItem.town | townString }}
                  </span>
                </el-form-item>
              </el-col> -->
              <el-col :span="20">
                <el-form-item label="详细地址">
                  <span>{{ enterpriseItem.address || '（未留）' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="联系电话">
                  <span>{{ enterpriseItem.phone || '（未留）' }}</span>
                </el-form-item>
              </el-col>
              <!-- 第三行 -->
              <el-col>
                <el-form-item label="企业简介">
                  {{ enterpriseItem.memo || '（未编写简介内容）' }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <!-- 右栏 -->
          <el-col :span="8">
            <el-form-item label="工商执照">
              <div style="height: 250px; border: dashed 1px #cfcfcf">
                <img
                  style="width: 100%; height: 100%"
                  :src="licenseImgUrl"
                  alt="营业执照（缩略图，点击可查看大图）"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="形象展示和资质荣誉">
          <el-row :gutter="20">
            <el-col :span="4" v-for="(item, i) in honorImgUrls" :key="i">
              <div class="photo">
                <img :src="item" :key="i" style="width: 188px" />
              </div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </template>
  </div>
</template>

<script>
import Editor from './Editor.vue'
import {
  enterpriseUpdate,
  enterpriseDetail,
  getHonorsByEnterpriseId,
} from '@/api/enterprise.js'
import towns from '@/common/towns.js'
export default {
  name: 'Detail',
  components: { Editor },
  props: {
    enterprise: {
      type: Object,
    },
  },
  data() {
    return {
      isEditing: false,
      enterpriseItem: {
        id: undefined,
        name: '',
        nameAbbr: '',
        credit: '',
        foundYear: '',
        town: '',
        address: '',
        phone: '',
        memo: '',
      },
      honorImgUrls: [],
      img: true,
      licenseImgUrl: '',
    }
  },
  filters: {
    townString(val) {
      let a = towns.find((item) => {
        return item.value == val
      })
      if (val != '' && val) {
        return a.label
      } else {
        return '未留'
      }
    },
  },
  computed: {
    editor() {
      return this.$refs.editor
    },
    id() {
      return this.enterpriseItem.id
    },
    imgBaseUrl() {
      return process.env.IMG_BASE_URL
    },
  },
  mounted() {
    console.log('【↑↑↑】', this.enterprise)
    this.enterpriseDetailGet()
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
  methods: {
    enterpriseDetailGet() {
      enterpriseDetail(this.$store.getters.currentEnterprise.id).then(
        (data) => {
          Object.keys(data.data).forEach((item) => {
            this.enterpriseItem[item] = data.data[item]
          })
          this.licenseImgUrl = `${this.imgBaseUrl}/enterprise/facade/${
            this.id
          }.jpg?v=${new Date().getTime()}`
          this.enterprisePhoto()
        }
      )
    },
    enterprisePhoto() {
      getHonorsByEnterpriseId(this.id).then((resp) => {
        const { imgBaseUrl, honorImgUrls } = this
        const urls = resp.data
        urls.forEach((u) => {
          honorImgUrls.push(`${imgBaseUrl}/${u.addr}`)
        })
        console.log('this.honorImgUrls111', honorImgUrls)
      })
    },
    startEdit() {
      this.$nextTick(() => {
        this.$router.push('enterprise-editor')
      })
    },
    cancelEdit() {
      this.isEditing = false
    },
    submitEdit() {
      let option = this.$refs.editor.getFormData()
      enterpriseUpdate(option).then((data) => {
        this.$emit('enterpriseDataGet')
        this.$emit('rest')
      })
      // TODO 写到服务器
      this.isEditing = false
    },
    leave() {
      if (this.isEditing) {
        this.$notify({
          title: '警告',
          message: '实体正在编辑，不可切换，请先确认保存或还原',
          type: 'warning',
          position: 'bottom-right',
        })
        return false
      }
      return true
    },
  },
}
</script>
<style scoped>
.photo {
  border: dashed 1px #cfcfcf;
  position: relative;
}
.del-button {
  position: absolute;
  right: 5px;
  opacity: 0;
}
.photo:hover .del-button {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/meta/enterprise/Detail.vue